// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all-rooms-switch[data-v-002490d3]{width:120px}.set-room-qty-button[data-v-002490d3]{height:39px}", ""]);
// Exports
module.exports = exports;
